import { Button, Checkbox, Col, Divider, Input, InputNumber, Row, Select, Skeleton } from "antd";
import API from "API";
import Exercise from "components/Exercise";
import React, { useCallback, useEffect, useState } from "react";
import { DeleteFilled } from '@ant-design/icons';
import { searchWithoutAccent } from "general_function";
import TextArea from "antd/es/input/TextArea";
import toastr from "toastr";

export default function ExerciseSessions() {
    const [grades, setGrades] = useState([]);
    const [selectedGrade, setSelectedGrade] = useState(null);
    const [selectedSubject, setSelectedSubject] = useState(null);
    const [getting, setGetting] = useState(true);
    const [creatingSection, setCreatingSection] = useState(false);
    const [selectedLesson, setSelectedLesson] = useState(null);
    const [selectedSection, setSelectedSection] = useState(null);
    const [selectedExercises, setSelectedExercises] = useState([]);
    const [require, setRequire] = useState("");
    const [gettingPDF, setGettingPDF] = useState(false);
    const [title, setTitle] = useState("");
    const [number, setNumber] = useState(5);
    useEffect(() => {
        setGetting(true);
        API.get("/grades/", { params: { page_size: 1000 } })
            .then(res => {
                setGrades(res.data.results);
                if (res.data.results.length > 0) {
                    setSelectedGrade(res.data.results[0]);
                }
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                setGetting(false);
            })
    }, [])
    useEffect(() => {
        if (!selectedLesson || selectedLesson.sections.length === 0) {
            setSelectedSection(null);
            return;
        }
        setSelectedSection(selectedLesson.sections[selectedLesson.sections.length - 1]);
    }, [selectedLesson])

    const createNewSection = useCallback(() => {
        setCreatingSection(true);
        API.post("/gen-exercise/", { lesson: selectedLesson.id, number: number, more_require: require })
            .then(res => {
                selectedLesson.sections = [...selectedLesson.sections, res.data];
                const newLesson = { ...selectedLesson };
                setSelectedLesson(newLesson);
                setGrades(grades => {
                    const gradeIndex = grades.findIndex(item => item.id === selectedGrade.id);
                    const subjectIndex = grades[gradeIndex].subjects.findIndex(item => item.id === selectedSubject.id);
                    const index = grades[gradeIndex].subjects[subjectIndex].lessons.findIndex(item => item.id === selectedLesson.id);
                    grades[gradeIndex].subjects[subjectIndex].lessons[index] = newLesson;
                    grades[gradeIndex].subjects[subjectIndex] = { ...grades[gradeIndex].subjects[subjectIndex] };
                    grades[gradeIndex] = { ...grades[gradeIndex] };
                    return [...grades];
                })
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                setCreatingSection(false);
            })
    }, [selectedGrade, selectedSubject, selectedLesson, number, require])

    useEffect(() => {
        if (!selectedGrade) return;
        if (selectedGrade.subjects.length > 0) {
            setSelectedSubject(selectedGrade.subjects[0]);
        }
    }, [selectedGrade])

    useEffect(() => {
        if (!selectedSubject) return;
        if (selectedSubject.lessons.length > 0) {
            setSelectedLesson(selectedSubject.lessons[0]);
        }
    }, [selectedSubject])

    return getting ? <Skeleton active /> : <>
        <b>Khối</b>
        <Select
            style={{ width: "100%" }}
            options={grades.map(item => ({
                value: item.id,
                label: item.grade
            }))}
            placeholder="Chọn khối"
            onChange={(value) => setSelectedGrade(grades.find(item => item.id === value))}
            value={selectedGrade?.id}
            disabled={creatingSection}
        />
        <Divider />
        {selectedGrade !== null && <>
            <b>Môn</b>
            <Select
                style={{ width: "100%" }}
                options={selectedGrade.subjects.map(item => ({
                    value: item.id,
                    label: item.name
                }))}
                placeholder="Chọn môn học"
                onChange={(value) => setSelectedSubject(selectedGrade.subjects.find(item => item.id === value))}
                value={selectedSubject?.id}
                disabled={creatingSection}
            />
            <Divider />
            {selectedSubject !== null && <>
                <b>Bài học</b>
                <Select
                    style={{ width: "100%" }}
                    options={selectedSubject.lessons.sort((a, b) => {
                        let numA = parseInt(a.title.match(/\d+/)[0], 10);
                        let numB = parseInt(b.title.match(/\d+/)[0], 10);

                        if (numA !== numB) return numA - numB;
                        return a.title.localeCompare(b.title, 'vi', { sensitivity: 'base' });
                    }).map(item => ({
                        value: item.id,
                        label: item.title
                    }))}
                    placeholder="Chọn bài học"
                    onChange={(value) => setSelectedLesson(selectedSubject.lessons.find(item => item.id === value))}
                    value={selectedLesson?.id}
                    disabled={creatingSection}
                    showSearch={true}
                    filterOption={searchWithoutAccent}
                />
                <Divider />
                <Row gutter={8}>
                    <Col span={12}>
                        <Divider>Ngân hàng câu hỏi</Divider>
                        {selectedLesson && <>
                            <div style={{ textAlign: "center", marginBottom: 5 }}>
                                Số lượng bài tập: <InputNumber placeholder="Số lượng bài tập" value={number} onChange={setNumber} precision={0} min={0} max={20} /> <br />
                                <TextArea placeholder="Yêu cầu cụ thể (nếu có)" value={require} onChange={(e) => setRequire(e.target.value)} style={{ marginBottom: 5 }}/>
                                <Button type="primary" disabled={creatingSection} loading={creatingSection} onClick={createNewSection}>
                                    Tạo bộ câu hỏi mới
                                </Button><br />
                                {creatingSection && <span style={{ color: "blue" }}>Đang khởi tạo bộ câu hỏi mới</span>}
                            </div>
                            <Select
                                style={{ width: "100%" }}
                                options={selectedLesson.sections.map((item, index) => ({
                                    value: item.id,
                                    label: `Bộ câu hỏi ${index + 1}`
                                }))}
                                placeholder="Chọn bộ câu hỏi"
                                onChange={(value) => setSelectedSection(selectedLesson.sections.find(item => item.id === value))}
                                value={selectedSection?.id}
                            />
                            {selectedSection?.exercises.map(item => <React.Fragment key={item.id}>
                                <Row>
                                    <Col span={2}>
                                        <Checkbox
                                            checked={selectedExercises.find(exercise => exercise.id === item.id)}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setSelectedExercises([...selectedExercises, item]);
                                                } else {
                                                    setSelectedExercises(selectedExercises.filter(exercise => exercise.id !== item.id));
                                                }
                                            }}
                                        />
                                    </Col>
                                    <Col span={22}>
                                        <Exercise item={item} />
                                    </Col>
                                </Row>

                                <Divider />
                            </React.Fragment>)}
                        </>}
                    </Col>
                    <Col span={12}>
                        <Divider>Phiếu bài tập</Divider>
                        <div style={{ textAlign: "center" }}>
                            <Button loading={gettingPDF} disabled={gettingPDF} type="primary" style={{ marginBottom: 3 }} onClick={() => {
                                if (!title.trim()) {
                                    toastr.error("Vui lòng nhập tiêu đề phiếu");
                                    return;
                                }
                                setGettingPDF(true);
                                API.post("/print-session/", {
                                    title,
                                    exercises: selectedExercises.map(item => item.id)
                                }, {responseType: "blob"})
                                .then(res => {
                                    const url = window.URL.createObjectURL(new Blob([res.data]));
                                    const link = document.createElement("a");
                                    link.href = url;
                                    link.setAttribute("download", `Phiếu bài tập - ${title}.pdf`);
                                    document.body.appendChild(link);
                                    link.click();
                                    link.remove();
                                    console.log("hữ")
                                })
                                .catch((error) => {
                                    console.log(error);
                                })
                                .finally(() => {
                                    setGettingPDF(false);
                                })
                            }}>In phiếu</Button>
                        </div>
                        <Input placeholder="Tiêu đề phiếu" value={title} onChange={(e) => setTitle(e.target.value)} />
                        <div style={{ border: "ridge silver 2px", backgroundColor: "white", padding: 10, marginTop: 5 }}>
                            {selectedExercises.map((item, index) => <React.Fragment key={item.id}>
                                <Row>
                                    <Col span={22}>
                                        <b>Bài {index + 1}:</b>
                                        <Exercise item={item} />
                                    </Col>
                                    <Col span={2} style={{ textAlign: "right" }}>
                                        <Button danger type="primary" onClick={() => setSelectedExercises(selectedExercises.filter(exercise => exercise.id !== item.id))}>
                                            <DeleteFilled />
                                        </Button>
                                    </Col>
                                </Row>
                                <Divider />
                            </React.Fragment>)}
                        </div>
                    </Col>
                </Row>
            </>}
        </>}
    </>;
}